import { TaskItem as BaseTaskItem } from "@tiptap/extension-task-item";

export const TaskItem = BaseTaskItem.configure({ nested: true });
